import React, { PureComponent } from 'react';
import { withRouter } from 'react-router-dom';
import { Root } from './ConflictReport.css';
import PageTitle from '../Layout/components/PageTitle';
import { Paper, Tabs, Tab, Table, TableHead, TableRow, TableCell, TableBody, TableFooter, TablePagination, Button, Dialog, InputBase } from '@material-ui/core';
import { roleStr, defaultPageSize, isRole, ROLES, ADD, VIEW, EDIT, ONGOING, COMPLETED, DISABLED } from '../../common/common';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import { BASE_URL } from '../../store/config';
import instance from '../../request/http';
import ReportInfo from './components/ReportInfo';
import AlertDialog from '../Layout/components/AlertDialog';
import Search from '@material-ui/icons/Search'
import { timeFormat } from '../../common/utils';

class ConflictReport extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            reportData: [
                {
                    id: 1,
                    reference_number: '001',
                    status: ONGOING,
                    create_time: '20210401',
                    update_time: '20210403',
                    client: {
                        first_name: 'zhang',
                        last_name: 'san',
                        full_name: 'zhang san',
                        email: '1234@gmail.com',
                        wechat: 'wei',
                        phone: '13322223333',
                    },
                }
            ],
            email: '',
            phone: '',
            wechat: '',
            client_name: '',
            dialogTitle: '',
            dialogData: {},
            dialogState: ADD,
            page_index: 1,
            page_size: defaultPageSize,
            total_items: 0,
            open: false,
            showAlert: false,
        }
        this.handleSearch = this.handleSearch.bind(this);
        this.handleChangePage = this.handleChangePage.bind(this);
        this.handleChangeRowsPerPage = this.handleChangeRowsPerPage.bind(this);
        this.handleCreateReport = this.handleCreateReport.bind(this);
        this.handleCreate = this.handleCreate.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleView = this.handleView.bind(this);
        this.handleEdit = this.handleEdit.bind(this);
        this.handleDel = this.handleDel.bind(this);
        this.handleAlertYes = this.handleAlertYes.bind(this);
        this.handleAlertNo = this.handleAlertNo.bind(this);
    }
    render() {
        const {
            email,
            phone,
            wechat,
            client_name,
            reportData,
            page_index,
            page_size,
            total_items,
            dialogTitle,
            dialogData,
            dialogState,
            open,
            showAlert,
        } = this.state;
        const statusView = (status) => {
            if (status === ONGOING) {
                return <div className="basic-status color-1 c">Ongoing</div>
            } else if (status === COMPLETED) {
                return <div className="basic-status color-2 c">Completed</div>
            } else if (status === DISABLED) {
                return <div className="basic-status color-3 c">Disabled</div>
            } else {
                return <div>--</div>
            }
        }
        return (
            <Root>
                <div className="head h h-t">
                    <PageTitle title="Conflict of interest check" subtitle="MANAGEMENT"></PageTitle>
                    <div className="f h h-r">
                        <Button variant="contained" color="primary" onClick={this.handleCreateReport}>request a check</Button>
                    </div>
                </div>
                <div className="tableTool h">
                    <div className="searchWapper h">
                        <div className="search c">
                            <Search />
                        </div>
                        <InputBase
                            placeholder="Search client name"
                            className="bgW"
                            inputProps={{ 'aria-label': 'Search' }}
                            onChange={e => this.handleSearch(e, 'client_name')}
                        />
                    </div>
                    <div className="searchWapper h m-20">
                        <div className="search c">
                            <Search />
                        </div>
                        <InputBase
                            placeholder="Search email"
                            className="bgW"
                            inputProps={{ 'aria-label': 'Search' }}
                            onChange={e => this.handleSearch(e, 'email')}
                        />
                    </div>
                    <div className="searchWapper h">
                        <div className="search c">
                            <Search />
                        </div>
                        <InputBase
                            placeholder="Search phone"
                            className="bgW"
                            inputProps={{ 'aria-label': 'Search' }}
                            onChange={e => this.handleSearch(e, 'phone')}
                        />
                    </div>
                    <div className="searchWapper h m-20">
                        <div className="search c">
                            <Search />
                        </div>
                        <InputBase
                            placeholder="Search wechat"
                            className="bgW"
                            inputProps={{ 'aria-label': 'Search' }}
                            onChange={e => this.handleSearch(e, 'wechat')}
                        />
                    </div>
                </div>
                <Paper className="tableWapper">
                    <Table stickyHeader className="table">
                        <TableHead>
                            <TableRow role="checkbox">
                                <TableCell>Reference Number</TableCell>
                                <TableCell>Client Name</TableCell>
                                <TableCell>Create Time</TableCell>
                                <TableCell>Update Time</TableCell>
                                <TableCell>Status</TableCell>
                                <TableCell>Others</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {reportData.map(row => (
                                <TableRow key={row.id} role="checkbox">
                                    <TableCell>{row.reference_number}</TableCell>
                                    <TableCell>{`${row.client.first_name} ${row.client.last_name}`}</TableCell>
                                    <TableCell>{timeFormat(row.create_time)}</TableCell>
                                    <TableCell>{timeFormat(row.update_time)}</TableCell>
                                    <TableCell>{statusView(row.status)}</TableCell>
                                    <TableCell>
                                        <div className="h h-l">
                                            <Button variant="outlined" color="primary" onClick={e => this.handleView(e, row)}>View</Button>
                                            {/* <Button variant="outlined" color="primary" onClick={e => this.handleEdit(e, row)}>Edit</Button> */}
                                            <DeleteForeverIcon className="del" onClick={e => this.handleDel(e, row)}></DeleteForeverIcon>
                                        </div>
                                    </TableCell>
                                </TableRow>
                            ))}
                            {reportData.length === 0 && (
                                <TableRow style={{ height: 300 }}>
                                    <TableCell colSpan={12} />
                                </TableRow>
                            )}
                        </TableBody>
                        <TableFooter>
                            <TableRow>
                                <TablePagination
                                    rowsPerPageOptions={[25, 50, 75]}
                                    colSpan={12}
                                    count={total_items}
                                    page={reportData.length === 0 ? 0 : page_index - 1}
                                    rowsPerPage={page_size}
                                    SelectProps={{
                                        inputProps: { 'arialabel': 'Rows per page' },
                                        native: true,
                                    }}
                                    onChangePage={this.handleChangePage}
                                    onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                />
                            </TableRow>
                        </TableFooter>
                    </Table>
                </Paper>
                <Dialog maxWidth={false} open={open}>
                    <ReportInfo
                        handleCreate={this.handleCreate}
                        handleCancel={this.handleCancel}
                        title={dialogTitle}
                        data={dialogData}
                        state={dialogState}
                    ></ReportInfo>
                </Dialog>
                <AlertDialog
                    open={showAlert}
                    title="Warning"
                    content="Are you sure to delete this report?"
                    handleAlertYes={this.handleAlertYes}
                    handleAlertNo={this.handleAlertNo}
                ></AlertDialog>
            </Root>
        );
    }
    componentDidMount() {
        this.doGetRport();
    }
    doGetRport() {
        const {
            email,
            phone,
            wechat,
            client_name,
            page_index,
            page_size,
        } = this.state;
        let params = {
            email,
            phone,
            wechat,
            client_name,
            page_index,
            page_size
        }
        this.getRport(params);
    }
    handleSearch(e, name) {
        const value = e.target.value;
        this.setState({
            [name]: value,
            page_index: 1
        }, () => {
            this.doGetRport();
        })
    }
    handleCreateReport() {
        this.openDialog("REQUEST A CHECK", ADD);
    }
    handleView(e, obj) {
        // this.setState(() => ({
        //     dialogData: obj
        // }))
        // this.openDialog("REPORT INFO", VIEW);
        this.openInfo(obj)
    }
    openInfo(data) {
        this.props.history.push(`/main/conflictReportInfo?id=${data.id}`);
    }
    handleEdit(e, obj) {
        this.setState(() => ({
            dialogData: obj
        }))
        console.log(obj)
        this.openDialog("EDIT REPORT", EDIT);
    }
    handleDel(e, obj) {
        this.setState(() => ({
            dialogData: obj,
            showAlert: true
        }))
    }
    handleCreate(client, related_persons) {
        this.addRport(client, related_persons);
        this.closeDialog();
    }
    handleCancel() {
        this.closeDialog();
    }
    handleAlertYes() {
        const { dialogData } = this.state;
        this.delRport(dialogData.id);
        this.setState(() => ({
            showAlert: false,
            dialogData: null
        }));
    }
    handleAlertNo() {
        this.setState(() => ({
            showAlert: false,
            dialogData: null
        }));
    }
    closeDialog() {
        this.setState(() => ({
            open: false,
            dialogData: null,
        }));
    }
    openDialog(title, state) {
        this.setState(() => ({
            open: true,
            dialogTitle: title,
            dialogState: state
        }));
    }
    handleChangePage(e, newPage) {
        this.setState({
            page_index: newPage + 1
        }, () => {
            this.getRport();
        })
    }
    handleChangeRowsPerPage(e) {
        const page_size = parseInt(e.target.value, 10);
        this.setState({
            page_index: 1,
            page_size
        }, () => {
            this.getRport();
        });
    }
    //---------------request---------------
    getRport(params) {
        instance.get(BASE_URL + 'conflict/report', { params }).then((res) => {
            const reportData = res.data.data;
            const pageObj = res.data.meta;
            const page_size = pageObj.page_size;
            const total_items = pageObj.total_items;
            console.log(reportData)
            this.setState(() => ({
                reportData,
                page_size,
                total_items
            }));
        })
    }
    addRport(client, related_persons) {
        let params = {
            client,
            related_persons
        }
        instance.post(BASE_URL + 'conflict/report', params).then((res) => {
            console.log(res.data.data);
            this.doGetRport();
        })
    }
    delRport(report_id) {
        instance.delete(BASE_URL + `conflict/report/${report_id}`).then((res) => {
            console.log("del standard_task", res);
            // this.showToast("Successfully deleted standard task", "success");
            this.doGetRport();
        })
    }
}

export default withRouter(ConflictReport);